import { useIntl } from 'react-intl';

import LoadingContainer from 'src/componentes/loading-container';
import { capitalizeFirstLetter } from 'src/utils/string';

const SecaoDefaultSimOuNao = ({
  isLoading,
  icon: Icon,
  titleId,
  value,
  detailsList,
}) => {
  const intl = useIntl();

  const renderDetails = () => {
    if (!detailsList || detailsList.length === 0) {
      return null;
    }

    return (
      <div className="text-md text-muted">
        {detailsList.map((item) => item.nome).join(' | ')}
      </div>
    );
  };

  return (
    <div className="border rounded-lg p-4 mb-4 shadow">
      <LoadingContainer isLoading={isLoading}>
        <div className="d-flex text-primary">
          {Icon && (
            <Icon
              style={{ width: '20px', marginBottom: '12px' }}
              className="mr-2"
            />
          )}
          <div className="text-primary text-base font-weight-bold mb-2 text-xl">
            {capitalizeFirstLetter(intl.formatMessage({ id: titleId }))}
          </div>
        </div>
        {!isLoading && (
          <>
            <p className="text-2xl font-weight-bold mb-1">
              {capitalizeFirstLetter(
                intl.formatMessage({ id: value ? 'sim' : 'nao' })
              )}
            </p>
            {renderDetails()}
          </>
        )}
      </LoadingContainer>
    </div>
  );
};

export default SecaoDefaultSimOuNao;
